import { Storage } from 'aws-amplify';
import { MAX_CACHE_AGE } from '@/constants/cores';

function isImageUrl(url) {
  return /\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(url);
}

function getS3ImageUrl(key, options = {
}) {
  return Storage.get(key, {
    ...options,
    expires: MAX_CACHE_AGE,
  });
}

function putS3ImageUrl(key, file, options = {
}) {
  return Storage.put(key, file, {
    ...options,
    cacheControl: `max-age=${MAX_CACHE_AGE}`,
  });
}
export {
  isImageUrl, getS3ImageUrl, putS3ImageUrl,
};